var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDroitoubli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6963 70H8.30368C3.73666 70 0 66.3027 0 61.6914V8.30861C0 3.73887 3.69514 0 8.30368 0H61.6963C66.2633 0 70 3.69733 70 8.30861V61.7329C70 66.3027 66.2633 70 61.6963 70Z",
    fill: "#BBD148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 31.875V25.625C19.25 16.9956 26.2456 10 34.875 10C43.5044 10 50.5 16.9956 50.5 25.625V31.875C53.9519 31.875 56.75 34.6732 56.75 38.125V53.75C56.75 57.2019 53.9519 60 50.5 60H19.25C15.7982 60 13 57.2019 13 53.75V38.125C13 34.6732 15.7982 31.875 19.25 31.875ZM44.25 25.625V31.875H25.5V25.625C25.5 20.4473 29.6973 16.25 34.875 16.25C40.0528 16.25 44.25 20.4473 44.25 25.625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2277 43C31.7768 41.8348 33.2584 41 35.0001 41C37.2092 41 39.0001 42.3432 39.0001 44C39.0001 45.3994 37.7224 46.5751 35.9943 46.9066C35.4519 47.0106 35.0001 47.4477 35.0001 48M35 51H35.01M44 46C44 50.9706 39.9706 55 35 55C30.0294 55 26 50.9706 26 46C26 41.0294 30.0294 37 35 37C39.9706 37 44 41.0294 44 46Z",
    stroke: "#BBD148",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroitoubli);
export default __webpack_public_path__ + "static/media/droit oubli.54b2837f46c4f7a2776ad8da598afcd3.svg";
export { ForwardRef as ReactComponent };